import React from 'react';
import styled from 'styled-components';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import { HashLink } from 'react-router-hash-link';

const InformationSectionWrapper = styled.section`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 40px 20px;
  gap: 20px;


  background: linear-gradient(180deg, #000000 0%, #B6B05F 100%);
  border-radius: 0px 0px 16px 16px;
`;

const Web3Subtitle = styled.h3`
  font-style: normal;
  font-weight: 300;
  font-size: 14px;
  line-height: 16px;
  letter-spacing: 0.2em;
  color: #FFFF56;
  margin-bottom: 8px;
  text-align: center;

  @media (max-width: 500px) {
    font-size: 12px;
    line-height: 14px;
    margin-bottom: 15px;
  }
`;

const Web3Title = styled.h2`
  font-style: normal;
  font-weight: 700;
  font-size: 52px;
  line-height: 75px;
  letter-spacing: 0.05em;
  color: #FFFFFF;
  margin-top: 0px;
  margin-bottom: 0px;
  text-align: center;

  @media (max-width: 500px) {
    font-size: 32px;
    line-height: 10px;
    margin-bottom: 30px;
  }
`;

const InformationContainer = styled.div`
  display: flex;
  justify-content: space-between;
  gap: 24px;
  flex-wrap: wrap;
  position: relative; 
  width:60%;

  @media (max-width: 500px) {
    flex-direction: row; 
    gap: 8px;
    width:90%;


  }
`;

const InformationCard = styled.div`
  position: relative;
  flex: 1;
  max-width: calc(25% - 24px);
  background-color: #000000;
  border-radius: 30px;
  overflow: hidden;
  margin-bottom: 24px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  aspect-ratio: 1/1;



  @media (max-width: 500px) {
    box-sizing: border-box;
    flex: 1 0 calc(50% - 8px);
    max-width: calc(50% - 8px);
    margin-bottom: 8px; 

 
  }

  &:hover {
    border: 1px solid #FFFF56;
    cursor: pointer;
  }
`;



const InformationImage = styled.img`
  
  max-width: 100%;
  height: auto;
  object-fit: cover;
  object-position: center center;
  margin-top:10px;


  padding: 10% 0% 0% 0%;
  
  @media (max-width: 500px) {
   
    max-width: 100%; /* 調整圖片最大寬度 */
    height: auto; /* 確保高度按比例縮放 */

  }
`;


const InformationText = styled.p`
  font-size: 18px;
  line-height: 32px;
  color: #FFFFFF;
  align-items: flex-start;
  position: relative; 
  text-align: center;
  margin-top:5px;

  @media (max-width: 500px) {
    font-size: 14px;
    line-height: 24px;
 
  }

  ${InformationCard}:hover & {
    color: #FFFF56;
  }
`;

const Information = () => (
  <InformationSectionWrapper>
    <Web3Subtitle>Information</Web3Subtitle>
    <Web3Title>相關資訊</Web3Title>
    <InformationContainer >
      {/* Goal 1 */}
      <InformationCard>
        <HashLink smooth to="/info#news" offset={-100} style={{ textDecoration: 'none' }}>
          <div>
            <InformationImage src="/images/Info1.png" alt="Goal 1" />
            <InformationText>最新消息</InformationText>
        
          </div>
        </HashLink>
      </InformationCard>

      {/* Goal 2 */}
      <InformationCard>
        <HashLink smooth to="/info#activities" offset={-100} style={{ textDecoration: 'none' }}>
          <div>
            <InformationImage src="/images/Info2.png" alt="Goal 2" />
            <InformationText>活動資訊</InformationText>
        
          </div>
        </HashLink>
      </InformationCard>

      {/* Goal 3 */}
      <InformationCard>
        <HashLink smooth to="/info#announcement" offset={-100} style={{ textDecoration: 'none' }}>
          <div>
            <InformationImage src="/images/Info3.png" alt="Goal 3" />
            <InformationText>網站宣告</InformationText>
            
          </div>
        </HashLink>
      </InformationCard>

      {/* Goal 4 */}
      <InformationCard>
        <HashLink smooth to="/info#cowork" offset={-100} style={{ textDecoration: 'none' }}>
          <div>
            <InformationImage src="/images/Info4.png" alt="Goal 4" />
            <InformationText>協作紀錄</InformationText>
          </div>
        </HashLink>
      </InformationCard>

      
      
    </InformationContainer>
    
   
  </InformationSectionWrapper>
);

export default Information;
